"use client";

import clsxm from "@/lib/clsxm";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import {AnimatePresence, motion} from "framer-motion";
import {useState, type ComponentPropsWithoutRef, type FC, type RefObject} from "react";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent: FC<
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    ref?: RefObject<HTMLDivElement>;
  }
> = ({ref, className, align = "start", sideOffset = 4, children, ...props}) => {
  const [open, setOpen] = useState(false);

  return (
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className="z-50 w-72 rounded-md p-0 outline-none"
      onPointerDownOutside={() => setOpen(false)}
      onEscapeKeyDown={() => setOpen(false)}
      onOpenAutoFocus={() => setOpen(true)}
      onCloseAutoFocus={() => setOpen(false)}
      {...props}>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{opacity: 0, scale: 0.95, y: -10}}
            animate={{opacity: 1, scale: 1, y: 0}}
            exit={{opacity: 0, scale: 0.95, y: -10}}
            transition={{duration: 0.2}}
            className={clsxm("bg-popover text-popover-foreground absolute border p-4 shadow-md", className)}>
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </PopoverPrimitive.Content>
  );
};
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export {Popover, PopoverContent, PopoverTrigger};
